import React from 'react';
import Sidebar from '../sidebar/Sidebar';
import Paper from 'material-ui/Paper';
import userContext from '../../services/userContext';
import './Project.css';

class Project extends React.Component {

    render() {
        if (!userContext.isLoggedIn()) {
            return <Paper className="login-panel" zDepth={1} >Please login</Paper>;
        }
        return (
            <div id="projectContainer">
                <Sidebar projectId={this.props.params.projectId} />
                <div id="projectContent">{this.props.children}</div>
            </div>
        )
    }
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/project/Project.js